import React from 'react';
import ReactDOM from 'react-dom';

import 'src/polyfills';
import '@amzn/fulfillment-hig-components/dist/index.css';
import App from "src/App";
import ErrorBoundary from "src/ErrorBoundary";
import {emitCounter, MetricMethod} from "src/metrics";
import {validateInjectedConfig} from "src/config";

// Validate build-time injected config and emit a per-key metric if anything is
// missing/malformed. Catches the "served but misconfigured endpoint" failure
// mode that server-side monitoring cannot see.
const configResult = validateInjectedConfig();
if (!configResult.valid) {
    configResult.invalidKeys.forEach(key => emitCounter(MetricMethod.Config, `InvalidConfig.${key}`, 1));
}

// Global JS-error counters. Counts only -- no message/stack is sent.
window.addEventListener('error', () => emitCounter(MetricMethod.JsError, 'WindowError', 1));
window.addEventListener('unhandledrejection', () => emitCounter(MetricMethod.JsError, 'UnhandledRejection', 1));

ReactDOM.render(
    <React.StrictMode>
        <ErrorBoundary>
            <App/>
        </ErrorBoundary>
    </React.StrictMode>,
    document.getElementById('root')
);
